import { ALL_PRIVATE_ROUTES } from '@app/router';

/**
 * Build a memoised exact-template lookup over a flat route list.
 * Exposed as a factory so tests can supply a mock route list.
 *
 * For production use, prefer the default export `findRouteByTemplate`
 * which is bound to `ALL_PRIVATE_ROUTES`.
 */
export const createFindRouteByTemplate = routes => {
  const index = new Map();
  routes.forEach(r => {
    if (r && r.path) index.set(r.path, r);
  });
  return template => (template ? index.get(template) || null : null);
};

export const findRouteByTemplate = createFindRouteByTemplate(ALL_PRIVATE_ROUTES);
